import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection, EditorialCallout } from '../../report/editorial';
import { resolveSectionCallout } from '../../../../lib/reportRendering/reportSectionCallouts';
import { GenerationEmissionsBlock } from '../../report/GenerationImpactProjectionBlocks';

export const AirQualityEmissionsSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const data = report.airQualityEmissions;
  const hasPromotedScenario = !!report.generationImpactProjection?.environmentalAndCommunity;
  const callout = resolveSectionCallout(report, 'airQualityEmissions');
  const hasData = hasPromotedScenario || (!!data && !!(
    data.baselineAqi || data.attainmentStatus || data.criteriaPollutants ||
    data.ghgImplications || data.constructionEmissions || data.generalConformity
  ));
  return (
    <SectionShell label={label} hasData={hasData} report={report}>
      <GenerationEmissionsBlock report={report} />
      {data?.baselineAqi && <EditorialSubsection theme={theme} label="Baseline AQI">{data.baselineAqi}</EditorialSubsection>}
      {data?.attainmentStatus && <EditorialSubsection theme={theme} label="Attainment Status">{data.attainmentStatus}</EditorialSubsection>}
      {callout && (
        <EditorialCallout theme={theme} tone={callout.tone} label={callout.label} style={{ marginTop: 8 }}>
          {callout.body}
        </EditorialCallout>
      )}
      {data?.criteriaPollutants && <EditorialSubsection theme={theme} label="Criteria Pollutants">{data.criteriaPollutants}</EditorialSubsection>}
      {data?.ghgImplications && <EditorialSubsection theme={theme} label="GHG Implications">{data.ghgImplications}</EditorialSubsection>}
      {data?.constructionEmissions && <EditorialSubsection theme={theme} label="Construction Emissions">{data.constructionEmissions}</EditorialSubsection>}
      {data?.generalConformity && <EditorialSubsection theme={theme} label="General Conformity (40 CFR 93)">{data.generalConformity}</EditorialSubsection>}
    </SectionShell>
  );
};
